import { PET_FRIENDLY_LABEL } from "../constants.js";
function pluralize(singularName, pluralName, count, concat) {
    if (!count || count <= 0) return '';
    return `${concat ? ', ' : ''}${count} ${1 === count ? singularName : pluralName}`;
}
function getTravelerLabel({ adults = 0, children = 0, lapInfants = 0, rooms = 0 }) {
    const adultLabel = pluralize('Adult', 'Adults', adults, false);
    const childLabel = pluralize('Child', 'Children', children, true);
    const infantLabel = pluralize('Infant', 'Infants', lapInfants, true);
    const roomLabel = pluralize('Room', 'Rooms', rooms, true);
    let label = adultLabel;
    label += childLabel;
    label += infantLabel;
    label += roomLabel;
    const twoTypesOfChildren = children > 0 && lapInfants > 0;
    const travelerCount = (adults ?? 0) + (children ?? 0);
    const travelerLabel = `${travelerCount} Travelers` + infantLabel + roomLabel;
    return twoTypesOfChildren ? travelerLabel : label;
}
function withPetFriendlyLabel(label, isPetFriendly) {
    if (!isPetFriendly) return label;
    return label ? `${label}, ${PET_FRIENDLY_LABEL}` : PET_FRIENDLY_LABEL;
}
export { getTravelerLabel, withPetFriendlyLabel };
